export default "__VITE_ASSET__ByqthBXV__"